/**
 * Fix S / S6 — the floating draw offer, pinned above the tab body (a
 * sibling of it in `rail/Rail/View.tsx`, absolute like the existing
 * overlays: `stage/TournamentIdle`, `overlay/ResultOverlay`). Reuses
 * `EventDock/cards/DrawOfferCard` wholesale — the SAME model
 * (`useDrawOfferCardModel`) and View the Moves tab's dock already shows,
 * so Accept/Decline are the same actions and the copy cannot drift between
 * the two places it can appear.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {RADIUS, SPACE} from '../../../theme/tokens';
import {useV2Theme} from '../../../theme/useV2Theme';
import {DrawOfferCard} from '../EventDock/cards';

export type FloatingDrawOfferViewProps = {
  visible: boolean;
  opponentName: string;
};

export default React.memo(function FloatingDrawOfferView({
  visible,
  opponentName,
}: FloatingDrawOfferViewProps) {
  const tokens = useV2Theme(s => s.tokens);

  if (!visible) {
    return null;
  }

  return (
    <View
      style={[
        styles.wrap,
        {
          backgroundColor: tokens.surface,
          borderColor: tokens.evLine,
          boxShadow: tokens.sh2,
        } as any,
      ]}
      testID="v2-floating-draw-offer">
      <DrawOfferCard opponentName={opponentName} />
    </View>
  );
});

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    top: SPACE.md,
    left: SPACE.lg,
    right: SPACE.lg,
    borderRadius: RADIUS.event,
    borderWidth: 1,
    padding: SPACE.md,
    zIndex: 10,
  },
});
